import Dexie from "dexie";

export interface Environment {
	id: string;
	image: Uint8Array;
	when: number;
}

export interface ProjectFile {
	path: string;
	history: string;
	matrix: string;
}

const db = new Dexie("dopplexr") as Dexie & {
	environments: Dexie.Table<Environment, "id">;
	projectFiles: Dexie.Table<ProjectFile, "path">;
};
db.version(1).stores({
	environments: "id, image, when", // Primary key and indexed props
	projectFiles: "path, history, matrix",
});

export { db };
